import { render, staticRenderFns } from "./myPurchaseRecord.vue?vue&type=template&id=0564d35a&scoped=true&"
import script from "./myPurchaseRecord.vue?vue&type=script&lang=ts&"
export * from "./myPurchaseRecord.vue?vue&type=script&lang=ts&"
import style0 from "./myPurchaseRecord.vue?vue&type=style&index=0&id=0564d35a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0564d35a",
  null
  
)

export default component.exports